module.exports = __webpack_public_path__ + "img/2A.5c5e4791.jpeg";